var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Admin-Companies-Home"},[_c('h1',[_vm._v("Administration der Firmen")]),_c('ManageCompanies',{attrs:{"page":parseInt(_vm.page) || 1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }